var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',{staticClass:"love"},[_vm._v("Made with ❤️ in Hamburg, Germany.")]),_c('span',[_c('router-link',{attrs:{"to":{ name: 'imprint'}}},[_vm._v("Imprint")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }